export default __webpack_public_path__ + "static/media/bottomHappyHoli.a9726328.gif";